import { Check, ChevronsUpDown, X } from 'lucide-react'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { WorkspaceIcon } from './WorkspaceIcon'
import { rememberWorkspace, workspaceFromPath, workspaces } from '../model/workspaceCatalog'
import { workspaceToneClasses } from './workspaceTones'

export function WorkspaceSwitcher() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const current = workspaceFromPath(location.pathname)
  const choose = (code: typeof workspaces[number]['code'], path: string) => {
    rememberWorkspace(code)
    setOpen(false)
    navigate(path)
  }

  return <>
    <button type="button" onClick={() => setOpen(true)} className="flex h-9 min-w-0 max-w-36 items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-2.5 text-xs font-black text-slate-700 shadow-sm sm:max-w-44 sm:px-3" aria-label="Đổi nội dung học">
      {current && <WorkspaceIcon code={current.code} className="h-4 w-4 shrink-0 text-[#0068FF]" />}
      <span className="truncate">{current?.name ?? 'Nội dung học'}</span><ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-slate-400" />
    </button>
    {open && <div className="fixed inset-0 z-[100] grid place-items-center bg-slate-950/45 p-3 backdrop-blur-sm" onMouseDown={event => { if (event.target === event.currentTarget) setOpen(false) }}>
      <section role="dialog" aria-modal="true" aria-labelledby="workspace-switch-title" className="max-h-[90dvh] w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl">
        <header className="flex h-14 items-center border-b border-slate-100 px-4"><h2 id="workspace-switch-title" className="flex-1 text-base font-black">Chọn nội dung học</h2><button type="button" onClick={() => setOpen(false)} aria-label="Đóng" className="grid h-10 w-10 place-items-center rounded-full text-slate-500 hover:bg-slate-100"><X className="h-4 w-4" /></button></header>
        <div className="max-h-[calc(90dvh-3.5rem)] space-y-2 overflow-y-auto p-3">{workspaces.map(workspace => {
          const active = workspace.code === current?.code
          return <button key={workspace.code} type="button" disabled={!workspace.available} onClick={() => choose(workspace.code, workspace.path)} className={`flex min-h-16 w-full items-center gap-3 rounded-2xl border p-3 text-left ${active ? 'border-2 border-emerald-600' : 'border-slate-200'} ${workspace.available ? 'bg-white hover:bg-slate-50' : 'cursor-not-allowed bg-slate-50 opacity-65'}`}>
            <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl ${workspaceToneClasses[workspace.tone].icon}`}><WorkspaceIcon code={workspace.code} className="h-5 w-5" /></span>
            <span className="min-w-0 flex-1"><span className="block font-black text-slate-900">{workspace.name}</span><span className="mt-0.5 block truncate text-xs text-slate-500">{workspace.available ? workspace.description : 'Sắp ra mắt'}</span></span>
            {active && <Check className="h-5 w-5 shrink-0 text-emerald-600" />}
          </button>
        })}</div>
      </section>
    </div>}
  </>
}
